// Десктопные слайды
import slide1 from "../../images/slides/slide1.jpg";
import slide2 from "../../images/slides/slide2.jpg";
import slide3 from "../../images/slides/slide3.jpg";
import slide4 from "../../images/slides/slide4.jpg";

// Мобильные слайды
import slide1m from "../../images/slides/slide1m.jpg";
import slide2m from "../../images/slides/slide2m.jpg";
import slide3m from "../../images/slides/slide3m.jpg";
import slide4m from "../../images/slides/slide4m.jpg";

const slides = [
  {
    pathDesktop: slide1,
    pathMobile: slide1m,
    title: "Канализационные насосные установки",
    text: "Напорные установки Aquastrong DLT для отвода загрязненной или сточной воды",
  },
  {
    pathDesktop: slide2,
    pathMobile: slide2m,
    title: "Циркулярные и повысительные насосы Aquastrong",
    text: "Подходят для любых задач",
  },
  {
    pathDesktop: slide3,
    pathMobile: slide3m,
    title: "Дренажный насос для высокотемпературных стоков",
    text: "Проверено ПАО МОЭК",
  },
  {
    pathDesktop: slide4,
    pathMobile: slide4m,
    title: "Дренажные и канализационные насосы Aquastrong",
    text: "Большой выбор под самые разные задачи",
  },
];

export default slides;
